<template>
  <div v-if="loaded">
    <!-- Réorganise ton formulaire ici -->
    <b-tabs content-class="mt-3">
      <b-tab title="Informations" active>
        <b-row>
          <mh-input
            label="Initiales"
            mhClass="col-2"
            field="initiale"
            :table="negotiator"
            labelColsLg="0"
          ></mh-input>
          <mh-input
            label="Prénom"
            mhClass="col-4"
            field="prenom"
            :table="negotiator"
            labelColsLg="0"
          ></mh-input>
          <mh-input
            label="Nom"
            mhClass="col-4"
            field="nom"
            :table="negotiator"
            labelColsLg="0"
          ></mh-input>
          <mh-input
            label="Langue"
            mhClass="col-2"
            field="langue"
            labelColsLg="0"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Actif"
            mhClass="col-2"
            labelColsLg="0"
            field="active"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Avocat"
            mhClass="col-2"
            labelColsLg="0"
            field="avocat"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Indépendant"
            mhClass="col-2"
            field="independant"
            labelColsLg="0"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Liste rappels"
            labelColsLg="0"
            mhClass="col-3"
            field="liste_rappel"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Liste négos"
            mhClass="col-3"
            labelColsLg="0"
            field="liste_nego"
            :table="negotiator"
          ></mh-input>

          <mh-input
            label="Login"
            mhClass="col-4"
            labelColsLg="0"
            field="login"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Mot de passe"
            labelColsLg="0"
            type="password"
            mhClass="col-4"
            field="password"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Profil"
            labelColsLg="0"
            mhClass="col-4"
            field="profile"
            :table="negotiator"
          ></mh-input>

          <mh-input
            label="Télephone fixe"
            mhClass="col-3"
            field="tel"
            labelColsLg="0"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Numéro de GSM"
            mhClass="col-3"
            labelColsLg="0"
            field="gsm"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Courriel"
            mhClass="col-6"
            labelColsLg="0"
            field="email"
            :table="negotiator"
          ></mh-input>

          <mh-input
            label="Adresse complète"
            :mhClass="
              negotiator.independant.value == 'oui' ? 'col-9' : 'col-12'
            "
            field="adresse"
            :table="negotiator"
            debounce="400"
            labelColsLg="0"
            :autocomplete="{ field: 'google.places' }"
          ></mh-input>
          <mh-input
            v-if="negotiator.independant.value == 'oui'"
            label="Numéro de TVA"
            mhClass="col-3"
            field="tva"
            labelColsLg="0"
            :table="negotiator"
          ></mh-input>
          <mh-input
            label="Frais de déplacement"
            mhClass="col-6"
            field="frais_deplacement"
            :table="negotiator"
            labelColsLg="0"
            append="€"
          ></mh-input>
          <mh-input
            label="Aleter le négo an cas d'attribution de dossier"
            mhClass="col-6"
            field="alert_attribution"
            :table="negotiator"
            labelColsLg="0"
            append="€"
          ></mh-input>
        </b-row>
      </b-tab>
      <b-tab lazy title="Codes postaux">
        <b-alert show v-if="negotiator._conflict_cp">
          <h6>Conflit(s) détecté(s)</h6>
          <div v-for="(conflict, i) in negotiator._conflict_cp" :key="i">
            <label>{{ conflict.initiales }}</label>
            <b-badge
              class="ml-2"
              v-for="(code, j) in conflict.conflicts"
              :key="j"
              >{{ code }}</b-badge
            >
          </div>
        </b-alert>
        <div class="table-postal-codes">
          <div
            v-for="(province, index) in negotiator._postal_codes"
            :key="index"
          >
            <b-row>
              <b-col lg="8">
                <b-form-checkbox
                  plain
                  @input="toggleCps(index)"
                  v-model="negotiator._postal_codes[index].checked"
                  :indeterminate.sync="
                    negotiator._postal_codes[index].indeterminate
                  "
                >
                  {{ province.province }}
                </b-form-checkbox>
              </b-col>
              <b-col lg="4" class="text-right">
                <b-button
                  @click="province.visible = !province.visible"
                  class="mr-2 mb-2"
                  variant="info"
                  size="sm"
                  icon
                >
                  <b-icon-arrow-down-circle-fill
                    v-if="!province.visible"
                  ></b-icon-arrow-down-circle-fill>
                  <b-icon-arrow-up-circle-fill
                    v-else
                  ></b-icon-arrow-up-circle-fill>
                </b-button>
              </b-col>
            </b-row>
            <b-collapse v-model="province.visible">
              <table class="table table-striped">
                <tr v-for="(code, index2) in province.codes" :key="index2">
                  <td>
                    <input
                      type="checkbox"
                      :checked="
                        negotiator._postal_codes[index].codes[index2].selected
                      "
                    />
                    <strong class="mx-3">{{ code.code }}</strong
                    >{{ code.label }}
                  </td>
                </tr>
              </table>
            </b-collapse>
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <b-col lg="12">
      <hr />
    </b-col>
    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import negotiators from "@/services/negotiators";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Negotiator",
  components: {
    MhInput,
  },
  props: {
    negotiator_id: [Number, String],
  },
  data() {
    return {
      negotiator: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    toggleCps(index) {
      let value = this.negotiator._postal_codes[index].checked;
      this.negotiator._postal_codes[index].codes.forEach(
        (el) => (el.selected = value)
      );
    },
    load() {
      negotiators
        .negotiator({
          negotiator_id: this.negotiator_id,
        })
        .then((response) => {
          this.negotiator = response.data;
          this.loaded = true;
        });
    },

    save() {
      negotiators
        .update_negotiator({
          negotiator_id: this.negotiator_id,
          negotiator: this.negotiator,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("negotiator mise à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            for (let el in this.negotiator) {
              if (this.negotiator[el]) {
                this.negotiator[el].error = false;
              }
            }
            this.$emit("change");
            this.$emit("close");
          } else if (response.data.fail) {
            for (let el in this.negotiator) {
              if (this.negotiator[el]) {
                this.negotiator[el].error = false;
              }
            }
            response.data.fail.forEach((element) => {
              this.negotiator[element.field].error = element.errors.join(" ; ");
            });
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-postal-codes {
  height: 50vh;
  overflow-y: scroll;
}
</style>